/**
 * Bridge between non-React code and the ErrorContext snackbar.
 *
 * React Query v5 removed per-query onError callbacks, so user-facing error
 * notifications are dispatched from the global QueryCache/MutationCache
 * handlers — which live outside the React tree. ErrorProvider registers its
 * display function here on mount; notifyError is a no-op until it does.
 */
let notifier = null

export function registerErrorNotifier(fn) {
  notifier = fn
  return () => {
    if (notifier === fn) notifier = null
  }
}

export function notifyError(error, info = {}) {
  notifier?.(error, info)
}
